import { useState } from 'react'
import './ReplyToResponse.scoped.sass'
import { ReactComponent as ReplyIcon } from '@/assets/icons/reply-icon.svg'
// import { ReactComponent as ArrowRight } from '@/assets/icons/arrow-right.svg'
import classNames from 'classnames'
import NewMessageReplyForm from '@/pages/HomePage/FeedContent/Thread/CardMainSection/NewMessageReplyForm'

export function ReplyToResponse (props) {
  const { response, thread } = props
  const [showReplyInput, setShowReplyInput] = useState(false)

  return <div className='reply-to-response'>
    <div className="reply-buttons">
      <div className="button" onClick={() => setShowReplyInput(true)}>
        <ReplyIcon />
        <span>Reply</span>
      </div>
      { /* <div className="button">
        <ArrowRight />
        <span>Forward</span>
        </div> */ }
    </div>
    <div className={classNames('reply-input', { hidden: !showReplyInput })}>
      { thread.messages.length > 1 && response.repliable && <NewMessageReplyForm replyToResponse={true} thread={thread} message={response}/> }
    </div>
  </div>
}
